import { Outlet, useLocation } from 'react-router-dom'
import App from './App'
import NavBar from './Misc/NavBar'
import CatalogToolbar from './Catalogs/CatalogToolbar'
import { useEffect } from 'react'
import QuoteList from './QuoteList/QuoteList'
import QuoteValidation from './QuoteDetails/QuoteValidation'
import EditQuote from './EditQuote/EditQuote'
import TechnicalRequest from './EditQuote/steps/validate/TechnicalRequest'
import SupplierList from './SupplierList/SupplierList'
import ManufacturerList from './ManufacturerList/ManufacturerList'
import CatalogList from './CatalogList/CatalogList'
import LoadCatalog from './Admin/LoadCatalog'
import ProductCategories from './Admin/ProductCategories/ProductCategories'
import SupplierCatalogPage from './Catalogs/SupplierCatalog/SupplierCatalogPage'
import { tdSynnexCatalogConfig } from './Catalogs/TdSynnex/tdSynnexCatalogConfig'
import { ingramMicroCatalogConfig } from './Catalogs/IngramMicro/ingramMicroCatalogConfig'
import { dellCatalogConfig } from './Catalogs/Dell/dellCatalogConfig'
import { carahsoftCatalogConfig } from './Catalogs/Carahsoft/carahsoftCatalogConfig'
import ImpresCatalog from './Catalogs/Impres/ImpresCatalog'
import { ImpresCartProvider } from './Catalogs/Impres/ImpresCartContext'
import ImpresCartOverlay from './Catalogs/Impres/ImpresCartOverlay'
import { RepCodes } from '@impres-development/assets/client'
import { useRepCodes, useUser } from './hooks'

function RepCodesPage() {
  const user = useUser()
  const [repCodes, setRepCodes] = useRepCodes()
  return <RepCodes user={user} repCodes={repCodes} setRepCodes={setRepCodes} />
}

const routes = [
  {
    path: '/',
    element: <NavBarWrapper />,
    children: [
      {
        path: '/',
        element: <App />,
      },
      {
        path: '/quote',
        element: <QuoteList />,
      },
      {
        path: '/quote/:quoteId',
        element: <EditQuote />,
      },
      {
        path: '/quote/:quoteId/validation',
        element: <QuoteValidation />,
      },
      {
        path: '/quote/:quoteId/technicalrequest',
        element: <TechnicalRequest />,
      },
      {
        path: '/suppliermanagement/supplier',
        element: <SupplierList />,
      },
      {
        path: '/suppliermanagement/manufacturer',
        element: <ManufacturerList />,
      },
      {
        path: '/catalog/list',
        element: <CatalogList />,
      },
      {
        path: '/imprescatalogs/impres',
        element: <ImpresCatalog />,
      },
      {
        path: '/imprescatalogs/tdsynnex',
        element: <SupplierCatalogPage key="tdsynnex" config={tdSynnexCatalogConfig} />,
      },
      {
        path: '/imprescatalogs/ingrammicro',
        element: <SupplierCatalogPage key="ingrammicro" config={ingramMicroCatalogConfig} />,
      },
      {
        path: '/imprescatalogs/dell',
        element: <SupplierCatalogPage key="dell" config={dellCatalogConfig} />,
      },
      {
        path: '/imprescatalogs/carahsoft',
        element: <SupplierCatalogPage key="carahsoft" config={carahsoftCatalogConfig} />,
      },
      {
        path: '/catalog/:header/:contractNumber',
        element: <CatalogToolbar />,
      },
      {
        path: 'admin/loadCatalog',
        element: <LoadCatalog />,
      },
      {
        path: 'admin/productCategories',
        element: <ProductCategories />,
      },
      {
        path: '/repCodes',
        element: <RepCodesPage />,
      },
    ],
  },
]

function NavBarWrapper() {
  const pathname = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <ImpresCartProvider>
      <div className="app-shell">
        <NavBar />
        <Outlet />
      </div>
      <ImpresCartOverlay />
    </ImpresCartProvider>
  )
}

export type CatalogOutletContext = {
  filterOpen: boolean
  setFilterOpen: (open: boolean) => void
}

export default routes
